import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 19l4 -6l4 2l4 -5l4 4l0 5l-16 0","key":"svg-0"}],["path",{"d":"M4 12l3 -4l4 2l5 -6l4 4","key":"svg-1"}]]

const IconChartAreaLine = createReactComponent('outline', 'chart-area-line', 'ChartAreaLine', __iconNode);

export default IconChartAreaLine;